function deleteIds(array, ignoreAmount = false) {
    if (array === undefined || array === null)
        return undefined;

    return array.map(item => ({
        ...item,
        id: undefined,
        amount: ignoreAmount ? item.amount : undefined,
        tax_amount: undefined,
        discount_amount: undefined,
        children: deleteIds(item.children),
    }));
}

export function deleteAllIds(transaction) {
    const { items, form_items, bank_items, journal_items, term_items, deposit_items, fields } = transaction;

    // Do not copy the id for form, bank, journal & term items.
    return {
        ...transaction,
        id: undefined,
        items: deleteIds(items),
        form_items: deleteIds(form_items),
        bank_items: deleteIds(bank_items, true),
        journal_items: deleteIds(journal_items),
        term_items: deleteIds(term_items),
        deposit_items: deleteIds(deposit_items, true),
        fields: deleteIds(fields),
    };
}
